import { ApiHelper } from './helper/ApiHelper';

let API_PATH;

if (window.location.hostname === 'localhost') {
  API_PATH = 'https://marketplace.arivonixcloud.com';
} else {
  //API_PATH = `https://${window.location.hostname}`; // for Development
  API_PATH = 'https://marketplace.arivonixcloudx.com'; // for Production
}

const apiHelper = new ApiHelper();

class CommonServices {
  regionsApi() {
    const uri = `${API_PATH}/marketplace/regions`;
    return apiHelper.getCommon(uri);
  }
  getDetails(data) {
    const uri = `${API_PATH}/marketplace/company`;
    return apiHelper.postCommon(uri, data);
  }
  registerAPI(data) {
    const uri = `${API_PATH}/marketplace/company/register`;
    return apiHelper.postCommon(uri, data);
  }
  validateCompanyAPI(data) {
    const uri = `${API_PATH}/marketplace/validate_company_email`;
    return apiHelper.postCommon(uri, data);
  }
  subscriptionDetailsAPI() {
    const uri = `${API_PATH}/marketplace/subscription`;
    return apiHelper.getCommon(uri);
  }
  getCompanySubscriptionStatus(company_id) {
    const uri = `${API_PATH}/marketplace/company/${company_id}/company_subscription`;
    return apiHelper.getCommon(uri);
  }
}
export default CommonServices;
export { CommonServices };
